import { ExamRoomPreviewButton, QuestionReviewButton } from '@exam-management/exam-room-preview';
import { Flex, Divider, PaperSection } from '@shared/components';

import { useQSetReviewSubtask } from '../../providers';
import { PassingCriteriaDetails } from '../passing-criteria-details';
import { QConfigDetails } from '../qconfig-details';

export default function ExaminationDetails() {
  const {
    subtaskDetails: { id: subTaskId },
  } = useQSetReviewSubtask();

  return (
    <PaperSection
      title='Examination Details'
      endAdornment={
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(3),
          })}
        >
          <ExamRoomPreviewButton subtaskId={subTaskId} />
          <QuestionReviewButton />
        </Flex>
      }
    >
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
      >
        <QConfigDetails />
        <Divider sx={(theme) => ({ px: theme.spacing(6) })} />
        <PassingCriteriaDetails />
      </Flex>
    </PaperSection>
  );
}
